import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';
import EFPicture from '@elem/ui/ef-picture';

const System = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('OceanSmartMeterBackupSwitch');
    return (
        <div className={styles.system}>
            <div className="text-container">
                <h2>{t(`system_title`)}</h2>
                <p className="intro">{t(`system_intro`)}</p>
            </div>
            <EFPicture
                src={'https://websiteoss.ecoflow.com/upload/image/1750833100750/System_pc.jpg'}
                srcMobile={'https://websiteoss.ecoflow.com/upload/image/1751356211435/System_h5.jpeg'}
                alt={t('system_title')}
                className="banner"
            />
        </div>
    );
};

export default System;
